var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("account_tb.test_validation"),
            isTitleUpperCase: false,
          },
        },
        [
          _c(
            "b-button-group",
            {
              staticClass: "mt-3 mt-sm-0",
              staticStyle: { display: "grid", "grid-auto-flow": "column" },
            },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "b-button",
                {
                  key: index,
                  staticClass: "responsive-button",
                  attrs: {
                    variant: _vm.tabName === index ? "primary" : "secondary",
                  },
                  on: {
                    click: function ($event) {
                      _vm.tabName = index
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t(tab.translationKey)) +
                      "\n      "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "b-tabs",
            {
              attrs: { "nav-class": "d-none" },
              on: { input: _vm.onTabChange },
              model: {
                value: _vm.tabName,
                callback: function ($$v) {
                  _vm.tabName = $$v
                },
                expression: "tabName",
              },
            },
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("account_tb.all") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _vm.activateSpinnerTest
                        ? _c("spinner")
                        : _vm.pieChartDataAll
                        ? _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h3", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("account_tb.all")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "figure",
                              {
                                attrs: {
                                  role: "group",
                                  "aria-labelledby":
                                    "chart-title-all-" + _vm._uid,
                                },
                              },
                              [
                                _c(
                                  "figcaption",
                                  {
                                    staticClass: "sr-only",
                                    attrs: {
                                      id: "chart-title-all-" + _vm._uid,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "monitoring.chart_status_distribution_title"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { attrs: { "aria-hidden": true } },
                                  [
                                    _c("pie-chart", {
                                      ref: "pieChartAll",
                                      attrs: {
                                        id: "myPieChart",
                                        "chart-data": _vm.pieChartDataAll,
                                        options: _vm.chartOptionsAll,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "table",
                                  {
                                    staticClass: "sr-only",
                                    attrs: {
                                      "aria-label": _vm.$t(
                                        "monitoring.chart_data_table_label"
                                      ),
                                    },
                                  },
                                  [
                                    _c("caption", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "monitoring.chart_status_distribution_detail"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("monitoring.status_label")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("monitoring.count_label")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "monitoring.percentage_label"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.pieChartDataAll.datasets[0].data,
                                        function (value, index) {
                                          return _vm.pieChartDataAll
                                            ? _c("tr", { key: index }, [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pieChartDataAll
                                                          .labels[index]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(value)),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getPercentage(
                                                        value,
                                                        "all"
                                                      )
                                                    ) + "%"
                                                  ),
                                                ]),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("account_tb.responder") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _vm.activateSpinnerTest
                        ? _c("spinner")
                        : _vm.pieChartDataRes
                        ? _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h3", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("account_tb.responder")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "figure",
                              {
                                attrs: {
                                  role: "group",
                                  "aria-labelledby":
                                    "chart-title-res-" + _vm._uid,
                                },
                              },
                              [
                                _c(
                                  "figcaption",
                                  {
                                    staticClass: "sr-only",
                                    attrs: {
                                      id: "chart-title-res-" + _vm._uid,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "monitoring.chart_status_distribution_title"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(_vm.$t("account_tb.responder")) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { attrs: { "aria-hidden": true } },
                                  [
                                    _c("pie-chart", {
                                      ref: "pieChartRes",
                                      attrs: {
                                        "chart-data": _vm.pieChartDataRes,
                                        options: _vm.chartOptionsRes,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "table",
                                  {
                                    staticClass: "sr-only",
                                    attrs: {
                                      "aria-label": _vm.$t(
                                        "monitoring.chart_data_table_label"
                                      ),
                                    },
                                  },
                                  [
                                    _c("caption", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "monitoring.chart_status_distribution_detail"
                                          )
                                        ) +
                                          " - " +
                                          _vm._s(_vm.$t("account_tb.responder"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("monitoring.status_label")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("monitoring.count_label")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "monitoring.percentage_label"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.pieChartDataRes.datasets[0].data,
                                        function (value, index) {
                                          return _vm.pieChartDataRes
                                            ? _c("tr", { key: index }, [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pieChartDataRes
                                                          .labels[index]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(value)),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getPercentage(
                                                        value,
                                                        "resp"
                                                      )
                                                    ) + "%"
                                                  ),
                                                ]),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("account_tb.requester") } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _vm.activateSpinnerTest
                        ? _c("spinner")
                        : _vm.pieChartDataReq
                        ? _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h3", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("account_tb.requester")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "figure",
                              {
                                attrs: {
                                  role: "group",
                                  "aria-labelledby":
                                    "chart-title-req-" + _vm._uid,
                                },
                              },
                              [
                                _c(
                                  "figcaption",
                                  {
                                    staticClass: "sr-only",
                                    attrs: {
                                      id: "chart-title-req-" + _vm._uid,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "monitoring.chart_status_distribution_title"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(_vm.$t("account_tb.requester")) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { attrs: { "aria-hidden": true } },
                                  [
                                    _c("pie-chart", {
                                      ref: "pieChartReq",
                                      attrs: {
                                        "chart-data": _vm.pieChartDataReq,
                                        options: _vm.chartOptionsReq,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "table",
                                  {
                                    staticClass: "sr-only",
                                    attrs: {
                                      "aria-label": _vm.$t(
                                        "monitoring.chart_data_table_label"
                                      ),
                                    },
                                  },
                                  [
                                    _c("caption", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "monitoring.chart_status_distribution_detail"
                                          )
                                        ) +
                                          " - " +
                                          _vm._s(_vm.$t("account_tb.requester"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("monitoring.status_label")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("monitoring.count_label")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { attrs: { scope: "col" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "monitoring.percentage_label"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.pieChartDataReq.datasets[0].data,
                                        function (value, index) {
                                          return _vm.pieChartDataReq
                                            ? _c("tr", { key: index }, [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pieChartDataReq
                                                          .labels[index]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(value)),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getPercentage(
                                                        value,
                                                        "req"
                                                      )
                                                    ) + "%"
                                                  ),
                                                ]),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }